import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 发布互动咨询
 */
export const post = (data: any): Promise<string> => {
    return axios.post(`${baseURL}/Interactive`, data)
}

export const get = (data: any): Promise<Array<any>> => {
    return axios.get(`${baseURL}/Interactive`, { params: data })
}

export const getHomeList = (data: any): Promise<Array<any>> => {
    return axios.get(`${baseURL}/Interactive/GetHomeList`, { params: data })
}